import { gql } from '@apollo/client';

export const coachAvailabilityFiltersQuery = gql`
  query coachAvailabilityFilters {
    coachAvailabilityFilters {
      programs {
        id
        value
        color
      }
      coaches {
        id
        value
        data {
          id
          fullName
          nickName
        }
      }
      categories {
        id
        category {
          id
          name
          type
          categoryOptions {
            id
            name
          }
        }
      }
    }
  }
`;
export const getAvailabilityDateTimes = gql`
  query availabilityDateTimes($input: AvailabilityDateTimesSearchInput) {
    availabilityDateTimes(input: $input) {
      id
      resourceId
      entityType
      date
      startTime
      endTime
    }
  }
`;
export const getClassEventDates = gql`
  query classEventDates($ids: [Int]) {
    classEventDates(ids: $ids) {
      eventId
      eventDates {
        id
        startDateTimeInUTC
      }
    }
  }
`;
export const participantRolesQuery = gql`
  query participantRoles($franchiseId: Int) {
    participantRoles(franchiseId: $franchiseId) {
      id
      franchiseId
      description
      abbrevation
      title
      sort
      isActive
      isDefaultRole
      isArchive
    }
  }
`;

export const coachAvailabilityScheduleQuery = gql`
  query coachAvailabilitySchedule(
    $accountFilters: CustomerSearchInput
    $availabilityFilters: AvailabilityDateTimesSearchInput
  ) {
    coachAvailabilitySchedule(
      accountFilters: $accountFilters
      availabilityFilters: $availabilityFilters
    ) {
      paging {
        page
        pageSize
        total
      }
      results {
        id
        fullName
        firstName
        lastName
        phone
        email
        nickName
        picture {
          id
          image
        }
        categoryValues {
          id
          categoryId
          category {
            id
            name
            type
          }
          categoryOptionId
          categoryOption {
            id
            name
          }
          fieldType
          value
          categoryType
        }
        coachAvailability {
          id
          resourceId
          entityType
          date
          startTime
          endTime
        }
        coachEventDates {
          id
          eventId
          start
          end
          staffAssignments
          attendanceStatus
          isActive
          startTime
          singleDayParticipants
          activeParticipants
          endTime
          startDateTimeInUTC
          endDateTimeInUTC
          eventDateParticipant {
            id
            accountId
          }
          scheduledTimeOffId
          scheduledTimeOff {
            id
            startDate
            endDate
            startTime
            endTime
            resourceId
            status
            isPaid
            categoryId
            category {
              id
              name
              isPaid
            }
          }
          overriddenLocation {
            id
            label
            name
            gis {
              zipcode
              longitude
              latitude
              timezone
            }
          }
          event {
            id
            label
            code
            effectiveName
            startTime
            ageRangeLabel
            endTime
            location {
              id
              name
              city
              state
              type
              zipcode
              address
            }
            program {
              id
              name
              logoUrl
              shortDescription
              color
              abbreviation
            }
            franchise {
              id
              name
              code
            }
          }
        }
      }
    }
  }
`;

export const conflictingEventDatesQuery = gql`
  query conflictingEventDates($input: ConflictingEventDatesInput) {
    conflictingEventDates(input: $input) {
      totalDates
      eventDates {
        id
        startDateTimeInUTC
        startTime
        endTime
        endDateTimeInUTC
        staffAssignments
        scheduledTimeOffId
        scheduledTimeOff {
          id
          startDate
          endDate
          startTime
          endTime
          resourceId
          status
          isPaid
          categoryId
          category {
            id
            name
            isPaid
          }
        }

        overriddenLocation {
          id
          label
          name
          gis {
            zipcode
            longitude
            latitude
            timezone
          }
        }
        event {
          id
          label
          code
          effectiveName
          startTime
          ageRangeLabel
          endTime
          location {
            id
            name
            city
            state
            zipcode
            address
          }
          program {
            id
            name
            color
          }
          franchise {
            id
            name
            code
          }
        }
      }
    }
  }
`;

export const scheduleCoachesMutation = gql`
  mutation scheduleCoaches($input: [ScheduleCoachesInput]) {
    scheduleCoaches(input: $input) {
      id
      taskName
      taskStatus
    }
  }
`;
export const franchiseeGetById = gql`
  query franchise($id: ID) {
    franchise(id: $id) {
      id
      settings {
        bufferOrOverlapTimeForAvailability
        availabilityOverlapBufferMode
        allowedConflicts
        isUsingRatios
      }
    }
  }
`;
